module.exports = __webpack_public_path__ + "img/JourneyBinderCoverPage.70dcee11.jpg";